<template>
    <div :class="'shotcode' + (this.size ? ' shotcode--' + size : '')">
        <svg ref="svg" viewBox="0 0 100 100" class="shotcode__svg"></svg>
    </div>
</template>
<script>

    /**
     * Vue Component to use with "inline-template" in twig templates.
     *
     * As long as it is inside a parent vue-container (see "utils/vueContainer")
     * is mounted automatically and can be nested as far as you want.
     *
     * <carousel inline-template>
     *    <div class="carousel">
     *    </div>
     * </carousel>
     *
     *
     */
    export default {

        name: 'Shotcode',

        data() {
            return {
                string: ""
            };
        },

        mounted() {
            this.renderShotcode(this.text+"", this.colors); // Convert it to a string

            if (this.refresh) {
                this.interval = setInterval(() => { requestAnimationFrame(this.changeText)}, 5000);
            }
            // setTimeout(this.changeText, 1000);
        },

        beforeDestroy() {
            clearInterval(this.interval);
        },

        props: {
            text: {
                required: true
            },
            colors: {
                default: () => { return ['#000', '#000', '#000'] },
                type: Array
            },
            refresh: {
                default: false,
                type: Boolean
            },
            size: {
                default: '',
                type: String
            }
        },

        methods: {
            makeid(length) {
                var result           = '';
                var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var charactersLength = characters.length;
                for ( var i = 0; i < length; i++ ) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            },
            changeText() {
                this.string = this.makeid(this.text.length);
                this.renderShotcode(this.string);
            },
            renderShotcode(inputString, inputColours) {
                var svg_ = this.$refs.svg;

                var xor = true;
                var ring_width = 6;
                var ring_increment = 2;
                var colour_array = inputColours && inputColours.length ? [inputColours[0], inputColours[0], inputColours[0], inputColours[1], inputColours[1], inputColours[1], inputColours[2], inputColours[2], inputColours[2], '#000000'] : ["#000", "#000", "#000", "#000", "#000", "#000", "#000", "#000", "#000", "#000000"];
                var xor_value = 0xAA;
                var bounding_circle = false;
                var unrolled = false;
                var start_ring = 2;
                var bytes_per_sector = 1;
                var counter_clockwise = false;
                var bit_order = 'lsb';
                var which_parity = 'mark';
                var bits_per_byte = 9;

                var exponential = false;
                var first_byte_offset = first_byte_for_ring(start_ring, ring_increment, exponential);
                var center_x = 50;
                var center_y = 50;



                var ring_params = {
                    center_x,
                    center_y,

                    start_ring,
                    bytes_per_sector,
                    ring_increment,
                    first_ring_offset: first_byte_offset,
                    first_byte_offset,
                    ring_width,

                    counter_clockwise,
                    bit_order,
                    which_parity,
                    bits_per_byte,
                    xor_value,
                    exponential,

                    colour_array,
                    unrolled,
                    bounding_circle
                };


                function polarToCartesianCoordinates(centerX, centerY, radius, angleInDegrees) {
                    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

                    return {
                        x: centerX + (radius * Math.cos(angleInRadians)),
                        y: centerY + (radius * Math.sin(angleInRadians))
                    };
                }

                function describeSVGArc(center_x, center_y, inner_radius, outer_radius, startAngle, endAngle) {
                    var inner_start = polarToCartesianCoordinates(center_x, center_y, inner_radius, endAngle);
                    var inner_end = polarToCartesianCoordinates(center_x, center_y, inner_radius, startAngle);
                    var outer_start = polarToCartesianCoordinates(center_x, center_y, outer_radius, endAngle);
                    var outer_end = polarToCartesianCoordinates(center_x, center_y, outer_radius, startAngle);

                    var arcSweep = endAngle - startAngle <= 180 ? "0" : "1";

                    var d = [
                        "M", outer_start.x, outer_start.y,
                        "A", outer_radius, outer_radius, 0, arcSweep, 0, outer_end.x, outer_end.y,
                        "L", inner_end.x, inner_end.y,
                        "A", inner_radius, inner_radius, 0, arcSweep, 1, inner_start.x, inner_start.y,
                        "L", outer_start.x, outer_start.y
                    ].join(" ");

                    return d;
                }

                function first_byte_for_ring(ring, step_size, log) { //base = step_size for log
                    if (ring <= 0) return 0;
                    if (step_size == 0) {
                        return ring;
                    }
                    ring -= 1; //As we need to calculate the capacity upto this ring.
                    if (log) {
                        return ((1 - Math.pow(step_size, ring)) / (1 - step_size)) * step_size + 1;
                    }
                    return step_size / 2.0 * (ring * ring + ring) + 1;
                }

                //calculate ring and byte in the ring where number of bytes in ring = ring + 1
                function ring_index(i, step_size) {
                    if (step_size == 0) {
                        return {
                            ring: i,
                            byte_in_ring: 0,
                            bytes_in_this_ring: 1,
                            ring_total_capacity: i
                        };
                    }
                    var a_b = step_size / 2.0;
                    var _ring = Math.ceil((-a_b + Math.sqrt(a_b * a_b - 4 * a_b * (-i))) / (2 * a_b));
                    var _num_in_ring = _ring * step_size; //Ring * step_size
                    var _rings_total_capacity = a_b * (_ring * _ring + _ring); //step_size/2 * (n2+n)
                    var _byte_in_ring = _num_in_ring - _rings_total_capacity + i - 1;
                    return {
                        ring: _ring,
                        byte_in_ring: _byte_in_ring,
                        bytes_in_this_ring: _num_in_ring,
                        ring_total_capacity: _rings_total_capacity
                    };
                }

                function ring_index_log(i, base) {
                    if (base <= 1) {
                        return {
                            ring: i,
                            byte_in_ring: 0,
                            bytes_in_this_ring: 1,
                            ring_total_capacity: i
                        };
                    }
                    //fudge factor for the .99999999 case we got with base 3.
                    var _ring = Math.floor(Math.log((1 - (i - 1) / base * (1 - base))) / Math.log(base) + 0.0000000001) + 1;
                    var _num_in_ring = Math.pow(base, _ring); //Each ring is power of the base.
                    var _rings_total_capacity = ((1 - Math.pow(base, _ring)) / (1 - base)) * base;
                    var _byte_in_ring = _num_in_ring - _rings_total_capacity + i - 1;
                    return {
                        ring: _ring,
                        byte_in_ring: _byte_in_ring,
                        bytes_in_this_ring: _num_in_ring,
                        ring_total_capacity: _rings_total_capacity
                    };
                }


                function drawCircleArc(rp, inner_radius, outer_radius, start_angle, end_angle, colour) {
                    var newPath = document.createElementNS("http://www.w3.org/2000/svg", 'path');

                    if (rp.counter_clockwise) {
                        t = 360 - start_angle;
                        start_angle = 360 - end_angle;
                        end_angle = t;
                    }
                    newPath.setAttribute("d", describeSVGArc(rp.center_x, rp.center_y, inner_radius, outer_radius, start_angle, end_angle)); //Set path's data
                    newPath.style.stroke = colour; //Set stroke colour
                    newPath.style.fill = colour; //Set fill colour
                    newPath.style.strokeWidth = "0.25"; //Set stroke width

                    svg_.appendChild(newPath);
                }

                function drawCircleBit(rp, ring, sectors_in_ring, bit_index, colour) {
                    var radius = rp.ring_width * ring;
                    var arc_angle = 360 / (rp.bytes_per_sector * sectors_in_ring * rp.bits_per_byte); //ring * ring_increment
                    var start_angle = arc_angle * bit_index;
                    drawCircleArc(rp, radius, radius + rp.ring_width, start_angle, start_angle + arc_angle, colour)
                }

                function drawRectBit(center_x, center_y, ring, rect_width, bit_index, colour) {
                    var radius = rect_width * ring;
                    var newRect = document.createElementNS("http://www.w3.org/2000/svg", 'rect');

                    newRect.setAttribute("x", center_x + rect_width / 1.6 * bit_index);
                    newRect.setAttribute("y", center_y + radius);
                    newRect.setAttribute("width", rect_width / 1.6);
                    newRect.setAttribute("height", rect_width);
                    newRect.style.fill = colour; //Set fill colour
                    newRect.style.stroke = "black"; //Set stroke colour
                    newRect.style.strokeWidth = "0.25"; //Set stroke width

                    svg_.appendChild(newRect);
                }


                function drawCircle(center_x, center_y, radius, stroke_width, colour) {
                    var newCircle = document.createElementNS("http://www.w3.org/2000/svg", 'circle');
                    newCircle.setAttribute("cx", center_x);
                    newCircle.setAttribute("cy", center_y);
                    newCircle.setAttribute("r", radius);
                    if (stroke_width == 0) {
                        newCircle.style.fill = colour; //Set fill colour
                        newCircle.style.stroke = colour; //Set stroke colour
                        newCircle.style.strokeWidth = "0.25"; //Set stroke width
                    } else {
                        newCircle.style.fill = "none"; //Set fill colour
                        newCircle.style.stroke = colour; //Set stroke colour
                        newCircle.style.strokeWidth = stroke_width; //Set stroke width
                    }
                    svg_.appendChild(newCircle);
                }

                function drawRing(center_x, center_y, outer_radius, stroke_width, colour) {
                    drawCircle(center_x, center_y, outer_radius, stroke_width, colour);
                }

                function drawDoubleCircle(center_x, center_y, ring_width, colour) {
                    drawCircle(center_x, center_y, ring_width / 2, 0, colour);
                    drawRing(center_x, center_y, ring_width * 0.7, ring_width * 0.15, colour);
                }

                function encode_string_to_bits(the_string) {
                    var array_of_bytes = [];
                    for (var i = 0; i < the_string.length; i++) {
                        array_of_bytes[i] = the_string.charCodeAt(i) & 0xFF;
                    }
                    return array_of_bytes;
                }

                function first_sector_for_ring(ring, ring_increment, exponential) { //base = rp.ring_increment for log
                    if (ring <= 0) return 0;
                    if (ring_increment == 0) return ring;
                    ring -= 1; //As we need to calculate the capacity up to this ring.
                    if (exponential) {
                        return ring_increment == 1 ? ring : ((1 - Math.pow(ring_increment, ring)) / (1 - ring_increment)) * ring_increment + 1;
                    }
                    return ring_increment / 2.0 * (ring * ring + ring) + 1;
                }


                function bit_index(sector_in_ring, bytes_per_sector, byte_in_sector, bits_per_byte, bit_in_byte) {
                    return (sector_in_ring * bytes_per_sector + byte_in_sector) * bits_per_byte + bit_in_byte;
                }

                function render_a_byte(the_byte, rp, ring, sectors_in_ring, sector_in_ring, byte_in_sector) {
                    var parity = rp.which_parity == 'even' ? 0 : 1; //even or odd, ignore none
                    var mask;
                    var lsb;
                    if (rp.bit_order == 'lsb') {
                        mask = 1;
                        lsb = true;
                    } else {
                        mask = 0x80;
                        lsb = false;
                    }

                    for (var j = 0; j < 8; j++) {
                        let bit_i = bit_index(sector_in_ring, rp.bytes_per_sector, byte_in_sector, rp.bits_per_byte, j);
                        if ((the_byte & mask) == mask) {
                            parity ^= 1;
                            if (rp.unrolled) {
                                drawRectBit(0, 0, ring, rp.ring_width, bit_i, rp.colour_array[j]);
                            } else {
                                drawCircleBit(rp, ring, sectors_in_ring, bit_i, rp.colour_array[j]);
                            }
                        } else if (rp.unrolled) {
                            drawRectBit(0, 0, ring, rp.ring_width, bit_i, "white");
                        }
                        if (lsb) the_byte >>>= 1;
                        else mask >>>= 1;
                    }

                    if (rp.which_parity != "none") {
                        if (rp.which_parity == "space") parity = 0;
                        else if (rp.which_parity == "mark") parity = 1;
                        let bit_i = bit_index(sector_in_ring, rp.bytes_per_sector, byte_in_sector, rp.bits_per_byte, 8);
                        if (parity == 1 && ring != null) {
                            if (rp.unrolled) {
                                drawRectBit(0, 0, ring, rp.ring_width, bit_i, rp.colour_array[8]);
                            } else {
                                drawCircleBit(rp, ring, sectors_in_ring, bit_i, rp.colour_array[8]);
                            }
                        } else if (rp.unrolled) {
                            drawRectBit(0, 0, ring, rp.ring_width, bit_i, "white");
                        }
                    }
                }


                // function render_bytes(array_of_bytes, log_scale, ring_increment, first_byte_offset) {
                //     var ring;
                //     for (var i = 0; i < array_of_bytes.length; i++) {
                //         ring = log_scale ? ring_index_log(i + first_byte_offset, ring_increment) : ring_index(i + first_byte_offset, ring_increment);
                //         //alert("Index " + i + " Ring " + (ring.ring) + " Byte  " + (ring.byte_in_ring) + " Ring Capacity " + ring.bytes_in_this_ring);
                //         var v = array_of_bytes[i];
                //         if (xor) {
                //             v = v ^ xor_value;
                //         } //every second bit in byte, to remove runs of 0's
                //         render_a_byte(v, ring.ring, ring_width, ring.bytes_in_this_ring, ring.byte_in_ring);
                //     }
                //     if (ring != null) {
                //         //Fill ring with xor value.
                //         if (xor) {
                //             for (var rb = ring.byte_in_ring + 1; rb < ring.bytes_in_this_ring; rb++) {
                //                 render_a_byte(xor_value, ring.ring, ring_width, ring.bytes_in_this_ring, rb);
                //             }
                //         }
                //         if (bounding_circle) {
                //             drawRing(center_x, center_y, ring_width * (ring.ring + 1.2), ring_width * 0.2, "black"); //bounding circle
                //         }
                //     }
                // }
                function render_bytes(array_of_bytes, rp) {
                    var byte_in_sector = 0;
                    var sector_in_ring = 0;
                    var ring = rp.start_ring;
                    var sectors_in_this_ring = sectors_in_a_ring(ring, rp);

                    for (var i = 0; i < array_of_bytes.length; i++) { //each character
                        var v = array_of_bytes[i] ^ rp.xor_value; //every second bit in byte, to remove runs of 0's
                        render_a_byte(v, rp, ring, sectors_in_this_ring, sector_in_ring, byte_in_sector);

                        byte_in_sector += 1;
                        if (byte_in_sector == rp.bytes_per_sector) {
                            /*Move to next ring*/
                            sector_in_ring += 1;
                            if (sector_in_ring == sectors_in_this_ring) {
                                ring += 1;
                                sectors_in_this_ring = sectors_in_a_ring(ring, rp);
                                sector_in_ring = 0;
                            }
                            byte_in_sector = 0;
                        }
                    }

                    var new_ring = (byte_in_sector == 0 && sector_in_ring == 0);

                    if (rp.xor_value != 0 && !new_ring) {
                        while (byte_in_sector < rp.bytes_per_sector) { //fill the last sector
                            render_a_byte(rp.xor_value, rp, ring, sectors_in_this_ring, sector_in_ring, byte_in_sector);
                            byte_in_sector += 1
                        }
                        sector_in_ring += 1; //move to next sector
                        while (sector_in_ring < sectors_in_this_ring) { //remainder of sectors in this ring
                            byte_in_sector = 0;
                            while (byte_in_sector < rp.bytes_per_sector) {
                                render_a_byte(rp.xor_value, rp, ring, sectors_in_this_ring, sector_in_ring, byte_in_sector);
                                byte_in_sector += 1
                            }
                            sector_in_ring += 1; //move to next sector
                        }
                    }

                    if (rp.bounding_circle) {
                        if (new_ring) ring -= 1;
                        drawRing(rp.center_x, rp.center_y, rp.ring_width * (ring + 1.2), rp.ring_width * 0.2, "black"); //bounding circle
                    }
                }

                function sectors_in_a_ring(ring, rp) {
                    if(rp.ring_increment == 0) return 1;
                    if(ring == 0) return 1;
                    return rp.exponential ? Math.pow(rp.ring_increment, ring) : (rp.ring_increment * ring);
                }

                function render_centre_byte(the_byte) {
                    var parity = which_parity == 'even' ? 0 : 1; //even or odd, ignore none
                    var mask;
                    var lsb;
                    if (bit_order == 'lsb') {
                        mask = 1;
                        lsb = true;
                    } else {
                        mask = 0x80;
                        lsb = false;
                    }

                    for (var j = 0; j < 8; j++) {
                        if ((the_byte & mask) == mask) {
                            parity ^= 1;
                            drawCircleArc(center_x, center_y, 0, ring_width, 360 / bits_per_byte * j, 360 / bits_per_byte * (j + 1), colour_array[j]);
                        }
                        if (lsb) the_byte >>>= 1;
                        else mask >>>= 1;
                    }
                    if (parity == 1) {
                        drawCircleArc(center_x, center_y, 0, ring_width, 360 / bits_per_byte * 8, 360, colour_array[8]);
                    }
                }

                function parseInt_local(s) {
                    if (s.substring(0, 2) == "0b") {
                        return parseInt(s.substring(2), 2);
                    } //0b doesn't work in my browser.
                    if (s.substring(0, 2) == "0a") {
                        return s.substring(2, 3).charCodeAt(0) & 0xFF;
                    } //hack to indicate ascii
                    return parseInt(s); //assume int10, 0x or 0
                }

                // function encode_text(the_form) {
                //     var _svg = document.getElementById("thesvg");
                //     while (_svg.lastChild) {
                //         _svg.removeChild(_svg.lastChild);
                //     }
                //     // start_ring = parseInt(the_form.start_ring.value);
                //     // ring_increment = parseInt(the_form.step_size.value);
                //     // first_byte_offset = first_byte_for_ring(start_ring, ring_increment, the_form.exponential.checked);
                //     // counter_clockwise = the_form.counter_clockwise.checked
                //     // bit_order = the_form.bit_order.value;
                //     // which_parity = the_form.parity.value;
                //     // bits_per_byte = which_parity == "none" ? 8 : 9;

                //     // ring_width = parseInt(the_form.ring_width.value);
                //     // center_x = parseInt(the_form.center_x.value);
                //     // center_y = parseInt(the_form.center_y.value);
                //     // xor_value = parseInt_local(the_form.xor_text.value);
                //     // xor = the_form.xor.checked;
                //     // colour_array = the_form.colour.checked ? ["red", "orange", "green", "lime", "aqua", "blue", "Fuchsia", "purple", "black"] : ["black", "black", "black", "black", "black", "black", "black", "black", "black"];
                //     // unrolled = the_form.unroll.checked
                //     // bounding_circle = the_form.bounding_circle.checked && !unrolled;
                //     // if (!unrolled) {
                //     //     if (the_form.center.value == "double_circle") {
                //     //         drawDoubleCircle(center_x, center_y, ring_width, "black");
                //     //     } else if (the_form.center.value == "center_circle") {
                //     //         drawCircle(center_x, center_y, ring_width, 0, "black");
                //     //     } else if (the_form.center.value == "ring") {
                //     //         drawRing(center_x, center_y, ring_width * 0.9, ring_width * 0.2, "black");
                //     //     } else if (the_form.center.value == "center_byte") {
                //     //         render_centre_byte(parseInt_local(the_form.center_byte_text.value));
                //     //     }
                //     // }

                //     render_bytes(encode_string_to_bits(the_form.the_text.value), the_form.exponential.checked, ring_increment, first_byte_offset);
                // }

                while (svg_.lastChild) {
                    svg_.removeChild(svg_.lastChild);
                }

                // draw_center(ring_params);
                return render_bytes(encode_string_to_bits(inputString), ring_params);

                // return render_bytes(encode_string_to_bits(inputString), exponential, ring_increment, first_byte_offset);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Shotcode.vue